module.exports = __webpack_public_path__ + "static/media/info.682f0b86.webp";